import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { useAppSelector } from '@/shared/store/hooks';
import { selectUser, selectRoles } from '@/shared/store/slices/authSlice';
import { ROLES } from '@/constants/roles';
import { AppBootstrapLoader } from '@/components/app/AppBootstrapLoader';

/**
 * Landing resolver for the root path ("/"). An unauthenticated visitor is sent
 * to the sign-in page; an authenticated user is forwarded to their home page
 * (platform console for SuperAdmin, timer for tenant users).
 */
export function RootRedirect() {
  const auth = useAuth();
  const user = useAppSelector(selectUser);
  const roles = useAppSelector(selectRoles);

  if (auth.isLoading) {
    return <AppBootstrapLoader />;
  }

  const isAuthenticated = auth.isAuthenticated || user !== null;
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  const landing = roles.includes(ROLES.SuperAdmin) ? '/platform/tenants' : '/timer';
  return <Navigate to={landing} replace />;
}
